export const NO_STATE = '';

export const APP = 'app';

export const BANKING = 'banking';

export const BILLING = 'billing';
export const BILLING_INVOICES = 'billing.invoices';
export const BILLING_INVOICE = 'billing.invoice';

export const CONTRACTORS = 'contractors';
export const CONTRACTORS_LIST = 'contractors.list';
export const CONTRACTORS_CREATE = 'contractors.create';
export const CONTRACTORS_DETAILS = 'contractors.details';
export const CONTRACTORS_DETAILS_ADDPAYROLL = 'contractors.details.add-to-payroll';
export const CONTRACTORS_DETAILS_PROFILE = 'contractors.details.profile';
export const CONTRACTORS_DETAILS_PROFILE_START_DATE = 'contractors.details.profile.start-date';
export const CONTRACTORS_DETAILS_PROFILE_WORKPLACES = 'contractors.details.profile.workplaces';
export const CONTRACTORS_DETAILS_PROFILE_LEGAL_ADDRESS = 'contractors.details.profile.legal-address';
export const CONTRACTORS_DETAILS_PAYMENTS = 'contractors.details.payments';
export const CONTRACTORS_DETAILS_DOCUMENTS = 'contractors.details.documents';

export const CONTRACTORS_INACTIVE = 'contractors.inactive';
export const CONTRACTORS_INACTIVE_LIST = 'contractors.inactive.list';
export const CONTRACTORS_INACTIVE_DETAILS = 'contractors.inactive.details';
export const CONTRACTORS_INACTIVE_DETAILS_PROFILE = 'contractors.inactive.details.profile';
export const CONTRACTORS_INACTIVE_DETAILS_PROFILE_START_DATE = 'contractors.inactive.details.profile.start-date';
export const CONTRACTORS_INACTIVE_DETAILS_PROFILE_RESTART_DATE = 'contractors.inactive.details.profile.restart-date';
export const CONTRACTORS_INACTIVE_DETAILS_PROFILE_LEGAL_ADDRESS = 'contractors.inactive.details.profile.legal-address';
export const CONTRACTORS_INACTIVE_DETAILS_PAYMENTS = 'contractors.inactive.details.payments';
export const CONTRACTORS_INACTIVE_DETAILS_DOCUMENTS = 'contractors.inactive.details.documents';

export const DEVSUPPORT = 'dev-support'
export const DEVSUPPORT_DASHBOARD = 'dev-support.dahsboard';

export const EMPLOYEES = 'employees';
export const EMPLOYEES_LIST = 'employees.list';
export const EMPLOYEES_CREATE = 'employees.create';
export const EMPLOYEES_FIND = 'employees.find';
export const EMPLOYEES_DETAILS = 'employees.details';
export const EMPLOYEES_DETAILS_ADDPAYROLL = 'employees.details.add-to-payroll';
export const EMPLOYEES_DETAILS_PROFILE = 'employees.details.profile';
export const EMPLOYEES_DETAILS_PROFILE_START_DATE = 'employees.details.profile.start-date';
export const EMPLOYEES_DETAILS_PROFILE_WORKPLACES = 'employees.details.profile.workplaces';
export const EMPLOYEES_DETAILS_PROFILE_PAYSCHEDULE = 'employees.details.profile.pay-schedule';
export const EMPLOYEES_DETAILS_PAYSTUBS = 'employees.details.paystubs';
export const EMPLOYEES_DETAILS_DOCUMENTS = 'employees.details.documents';
export const EMPLOYEES_DETAILS_DEDUCTIONS = 'employees.details.deductions';
export const EMPLOYEES_DETAILS_DEDUCTIONS_MANAGE = 'employees.details.deductions.manage';
export const EMPLOYEES_DETAILS_BENEFITS = 'employees.details.benefits';
export const EMPLOYEES_DETAILS_BENEFITS_MANAGE = 'employees.details.benefits.manage';
export const EMPLOYEES_DETAILS_WAGES = 'employees.details.wages';

export const EMPLOYEES_INACTIVE = 'employees.inactive';
export const EMPLOYEES_INACTIVE_LIST = 'employees.inactive.list';
export const EMPLOYEES_INACTIVE_DETAILS = 'employees.inactive.details';
export const EMPLOYEES_INACTIVE_DETAILS_PROFILE = 'employees.inactive.details.profile';
export const EMPLOYEES_INACTIVE_DETAILS_PROFILE_RESTART_DATE = 'employees.inactive.details.profile.restart-date';
export const EMPLOYEES_INACTIVE_DETAILS_WAGES = 'employees.inactive.details.wages';
export const EMPLOYEES_INACTIVE_DETAILS_PAYSTUBS = 'employees.inactive.details.paystubs';
export const EMPLOYEES_INACTIVE_DETAILS_DOCUMENTS = 'employees.inactive.details.documents';
export const EMPLOYEES_INACTIVE_DETAILS_DEDUCTIONS = 'employees.inactive.details.deductions';
export const EMPLOYEES_INACTIVE_DETAILS_DEDUCTIONS_MANAGE = 'employees.inactive.details.deductions.manage';
export const EMPLOYEES_INACTIVE_DETAILS_BENEFITS = 'employees.inactive.details.benefits';
export const EMPLOYEES_INACTIVE_DETAILS_BENEFITS_MANAGE = 'employees.inactive.details.benefits.manage';

export const ERROR = 'error';
export const ERROR_NOTFOUND = 'error.not-found';
export const ERROR_RESTRICTED = 'error.restricted';

export const LOGIN = 'login';
export const LOGOUT = 'logout';

export const GO = 'go';
export const GO_SSO = 'go.sso';
export const GO_EMAILVERIFICATION = 'go.email-verification';
export const GO_LINK = 'go.link';
export const GO_LOGIN = 'go.login';
export const GO_LOGIN_SENDCODE = 'go.login.send-code';
export const GO_LOGIN_ENTERCODE = 'go.login.enter-code';
export const GO_LOGIN_RESETPASSWORD = 'go.login.reset-password';

export const PASSWORD_VALIDATION_REQUEST = 'login.request-validation';
export const PASSWORD_VALIDATION_SUBMIT = 'login.submit-validation';
export const PASSWORD_RESET = 'login.reset-password';

export const PAYROLL = 'payroll';
export const PAYROLL_DETAILS = 'payroll.details';
export const PAYROLL_NEW = 'payroll.new';
export const PAYROLL_OFFCYCLE = 'payroll.off-cycle';
export const PAYROLL_OFFCYCLE_MANAGE = 'payroll.off-cycle.manage';
export const PAYROLL_HISTORY = 'payroll.history';
export const PAYROLL_HISTORY_DETAILS = 'payroll.history.details';

export const ONBOARDING = 'onboarding';

export const REPORTS = 'reports';
export const REPORTS_RUN = 'reports.run';
export const REPORTS_PAYROLLSUMMARY = 'reports.payroll-summary';
export const REPORTS_PAYROLLJOURNAL = 'reports.payroll-journal';
export const REPORTS_TAXLIABILITIES = 'reports.tax-liabilities';
export const REPORTS_BENEFITS = 'reports.benefits';
export const REPORTS_CONTRACTORPAYMENTS = 'reports.contractor-payments';
export const REPORTS_CHILDSUPPORTPAYMENTS = 'reports.child-support-payments';
export const REPORTS_W4EXEMPTSTATUS = 'reports.w4-exempt-status';

export const SETTINGS = 'settings';
export const SETTINGS_GENERAL = 'settings.general';
export const SETTINGS_MAPPING = 'settings.mapping';
export const SETTINGS_MAPPING_PAYROLL = 'settings.mapping.payroll';
export const SETTINGS_WORKPLACES = 'settings.workplaces';
export const SETTINGS_LEAVES_POLICIES = 'settings.leave-policies';
export const SETTINGS_LEAVES_POLICIES_CREATE = 'settings.leave-policies.create';
export const SETTINGS_LEAVES_POLICIES_NEWUNAVAILABLE = 'settings.leave-policies.new-unavailable';
export const SETTINGS_LEAVES_POLICIES_CREATE_STEP1 = 'settings.leave-policies.create.step-1';
export const SETTINGS_LEAVES_POLICIES_CREATE_STEP2 = 'settings.leave-policies.create.step-2';
export const SETTINGS_LEAVES_POLICIES_CREATE_STEP3 = 'settings.leave-policies.create.step-3';
export const SETTINGS_LEAVES_POLICIES_CREATE_STEP4 = 'settings.leave-policies.create.step-4';
export const SETTINGS_LEAVES_POLICIES_CREATE_STEP5 = 'settings.leave-policies.create.step-5';
export const SETTINGS_LEAVES_POLICIES_DETAILS = 'settings.leave-policies.details';
export const SETTINGS_LEAVES_POLICIES_DETAILS_EMPLOYEES = 'settings.leave-policies.details.employees';

export const TAXATION = 'taxation';
export const TAXATION_DOCUMENTS = 'taxation.documents';
export const TAXATION_DEPOSITS = 'taxation.deposits';
export const TAXATION_DEPOSITS_VIEW = 'taxation.deposits.view';
